export default "__VITE_ASSET__CRyhxojc__"